<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("storemanagement") }}
      </div>
      <router-link class="btn-blue" to="store-management"
        >{{ $tc("storemanagement", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="dropdown-curve-container pr-28px">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
                $tc("cinema", 1)
              }}</label>
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :text="selectedCinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Cinema"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCinema()"
                      v-on:keydown="onSearchCinema()"
                      v-on:search="onSearchCinema()"
                      v-model="searchCinema"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(cinema, cinemaIndex) in Cinemas"
                    :key="cinemaIndex"
                    href="#"
                    @click="onSelectCinema(cinema)"
                    >{{ cinema.cine_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <p class="error_message">
                <span v-if="submitted && selectedCinema.length == 0"
                  >Please Select Cinema.</span
                >
              </p>
            </div>
          </div>

          <div
            v-for="(list, listKey) in store_management"
            :key="listKey"
            class="col-md-12"
          >
            <div class="row mb-3">
              <div class="col-md-10">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-lg-4 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              type="text"
                              v-model="list.sm_store_name"
                              name="sm_store_name"
                              id="sm_store_name"
                              v-validate="{
                                required: 'required',
                                regex: /^[a-zA-Z0-9 ]*$/
                              }"
                              placeholder="Store Name"
                            />
                            <label>{{ $tc("sm_store_name", 2) }}</label>
                          </div>
                          <Tooltip :title="$t('sm_store_name_tooltip')" />
                        </div>
                        <p class="error_message">
                          <span
                            v-if="submitted && errors.has('sm_store_name')"
                            >{{ errors.first("sm_store_name") }}</span
                          >
                        </p>
                      </div>

                      <div class="col-lg-4 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              type="text"
                              v-model="list.sm_store_slug"
                              name="sm_store_slug"
                              id="sm_store_slug"
                              v-validate="{
                                required: 'required',
                                regex: /^[a-zA-Z0-9 ]*$/
                              }"
                              placeholder="Store Slug"
                            />
                            <label>{{ $tc("sm_store_slug", 2) }}</label>
                          </div>
                          <Tooltip :title="$t('sm_store_slug_tooltip')" />
                        </div>
                        <p class="error_message">
                          <span
                            v-if="submitted && errors.has('sm_store_slug')"
                            >{{ errors.first("sm_store_slug") }}</span
                          >
                        </p>
                      </div>

                      <!-- ConcessionLevels -->
                      <div class="col-lg-4 align-self-center mb-4">
                        <div class="dropdown-curve-container pr-28px">
                          <label
                            :class="list.sm_order.length > 0 ? 'shift-up' : ''"
                            >{{ $tc("order", 1) }}</label
                          >
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <b-dropdown
                              :text="list.sm_order"
                              variant="dropdown-curve"
                              class="w-100"
                            >
                              <b-dropdown-item
                                v-for="(loop, loopIndex) in orders"
                                :key="loopIndex"
                                href="#"
                                @click="onselectOrder(loop, listKey)"
                                >{{ loop }}</b-dropdown-item
                              >
                            </b-dropdown>
                          </div>
                          <p class="error_message">
                            <span v-if="submitted && list.sm_order.length == 0"
                              >Please select order.</span
                            >
                          </p>
                        </div>

                        <p class="error_message">
                          <span v-if="submitted && errors.has('sm_order')">{{
                            errors.first("sm_order")
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div
                        v-if="list.sm_order > 1 && StoreLevels.length > 0"
                        class="col-lg-4 align-self-center mb-4"
                      >
                        <div class="dropdown-curve-container pr-28px">
                          <label
                            :class="
                              list.selectedStore.length > 0 ? 'shift-up' : ''
                            "
                            >{{ $tc("store", 1) }}</label
                          >
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <b-dropdown
                              :text="list.selectedStore"
                              variant="dropdown-curve"
                              class="w-100"
                            >
                              <b-dropdown-item
                                v-for="(store, storeIndex) in StoreLevels"
                                :key="storeIndex"
                                href="#"
                                @click="onSelectStore(store, listKey)"
                                >{{ store.sm_store_name }}</b-dropdown-item
                              >
                            </b-dropdown>
                          </div>
                          <p class="error_message">
                            <span
                              v-if="submitted && list.selectedStore.length == 0"
                              >Please select parent store.</span
                            >
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-4 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          <label class="mb-0 mr-3">{{ $t("active") }}</label>
                          <label class="ios-switch ml-2">
                            <input
                              v-model="list.sm_is_active"
                              type="checkbox"
                              class="ios-checkbox"
                              checked
                            />
                            <span class="switch-slider"></span>
                          </label>
                        </div>
                        <p class="error_message">
                          <span></span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-2 border-left d-flex justify-content-center">
                <button
                  v-if="listKey === 0"
                  @click.prevent="onClickAdd()"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
                <button
                  v-else-if="listKey !== 0"
                  @click.prevent="onClickRemove(listKey)"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-12 text-center mt-4">
            <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">
              {{ $t("update") }}
            </button>
            <button v-on:click="onResetForm()" class="btn-black">
              {{ $t("reset") }}
            </button>
            <b-button
              class="btn-outline-grey"
              variant="default"
              to="store-management"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";

export default {
  name: "Edit Store Management",
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      isRoleID1: true,
      Cinemas: [],
      ConcessionLevels: [],
      StoreLevels: [],
      submitted: false,
      selectedCinema: "",
      selectedConcession: "",
      sm_id: "",
      cinema_id: null,
      concession_level_id: null,
      orders: ["1", "2", "3"],
      store_management: [
        {
          sm_parent_id: "",
          selectedStore: "",
          sm_store_name: "",
          sm_store_slug: "",
          sm_order: "",
          sm_is_active: true
        }
      ]
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.isRoleID1 = this.secureStore.get("USINFO").role_id;
    if (this.isRoleID1 == 1 || this.isRoleID1 == 2) {
      this.isRoleID = false;
    }
    this.getCinemas(obj);
    this.sm_id = this.$route.query.sm_id;
    this.getStoreManagementDetails(this.sm_id);
    // let obj = this.secureStore.get("USINFO").cinema_id;
    // this.isRoleID1 = this.secureStore.get("USINFO").role_id;
    // if (this.isRoleID1 == 1 || this.isRoleID1 == 2) {
    //   this.isRoleID = false;
    //   this.getCinemas();
    // } else {
    //   this.getCinemas(obj);
    // }
  },
  methods: {
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onClickAdd: function() {
      this.store_management.push({
        sm_parent_id: "",
        selectedStore: "",
        sm_store_name: "",
        sm_store_slug: "",
        sm_order: "",
        sm_is_active: true
      });
    },
    onClickRemove: function(index) {
      this.store_management.splice(index, 1);
    },
    getStoreManagementDetails: function(sm_id) {
      let payload = {
        tableName: "store_management",
        sm_id: sm_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            console.log("obj :", obj);
            this.store_management[0].sm_parent_id =
              data.Records[0].sm_parent_id;
            this.store_management[0].sm_id = data.Records[0].sm_id;
            this.store_management[0].sm_store_name =
              data.Records[0].sm_store_name;
            this.store_management[0].sm_store_slug =
              data.Records[0].sm_store_slug;
            this.store_management[0].sm_order = data.Records[0].sm_order.toString();
            this.store_management[0].sm_is_active =
              data.Records[0].sm_is_active == "Y" ? true : false;
            // this.cinema_id = data.Records[0].cinema_id;
            this.concession_level_id = data.Records[0].concession_level_id;
            // let obj = data.Records[0];
            // this.store_management.push(data.Records[0]);
            // this.sm_details.sm_is_active =
            //   obj.sm_is_active == "Y" ? true : false;
            console.log("this.store_management :", this.store_management);
            this.setCinema(obj.cinema_id);
            this.getStoreLevels(obj.cinema_id, obj.sm_parent_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onselectOrder: function(val, key) {
      this.store_management[key].sm_order = val;
      if (val > 1) {
        this.getStoreLevels(this.cinema_id);
      }
    },
    setCinema: function(cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getCinemas: function(cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            // this.Cinemas.map(x => {
            //   if (String(cine_id) === String(x.cine_id)) {
            //     this.selectedCinema = x.cine_name;
            //   }
            // });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectCinema: function(params) {
      this.selectedCinema = params.cine_name;
      this.cinema_id = params.cine_id;
      // this.sm_details.cinema_id = params.cine_id;
      this.searchCinema = "";
      this.onSearchCinema();
    },
    getStoreLevels: function(cinema_id, sm_parent_id) {
      // let payload = {
      //   tableName: "store_management",
      //   sm_is_active: "Y",
      //   cinema_id: cinema_id
      // };
      MasterService.GetStoreManagement({ cine_id: cinema_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.StoreLevels = data.Records;
            this.StoreLevels.map(x => {
              console.log("sm_parent_id :", sm_parent_id);
              if (String(sm_parent_id) == String(x.sm_id)) {
                this.store_management[0].selectedStore = x.sm_store_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectStore: function(store, index) {
      this.store_management[index].sm_parent_id = store.sm_id;
      this.store_management[index].selectedStore = store.sm_store_name;
    },
    onResetForm() {
      this.store_management = [
        {
          sm_parent_id: "",
          selectedStore: "",
          sm_store_name: "",
          sm_store_slug: "",
          sm_order: "",
          sm_is_active: true
        }
      ];
      this.selectedConcession = "";
      this.selectedCinema = "";
    },
    StoreValidation: function() {
      let count = 0;

      this.store_management.map(x => {
        if (x.sm_order == null || (x.sm_order != 1 && x.sm_parent_id == 0)) {
          count++;
        }
      });

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },
    onFinalSubmit: function(flag) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (this.cinema_id == null) {
          return;
        }
        if (this.StoreValidation()) {
          return;
        }
        if (valid) {
          let payload = {
            cinema_id: this.cinema_id,
            // sm_id: this.sm_id,
            concession_level_id: this.concession_level_id,
            store_management: this.store_management
          };
          PosFnbService.UpdateStoreManagement(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                if (flag) {
                  this.$toasted.show(data.message);
                  this.$router.push({
                    path: "store-management"
                  });
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StoreManagementComponents/editStoreManagement.vue